<template>

<fragment>

<div class="mobile-brand" :style="{marginTop: marginTop}" v-if="!$route.meta.isHome">

	<com-logo />

</div>

<div class="mobile" :style="{marginTop: mobileTop}" :class="{'has-scrolled': window.scrollY > 64}">

    <core-avatar type="context" class="mobile-context" v-on:click="onContextClick" v-if="!$route.meta.isCommunity">

        <i class="fa-sharp fa-caret-down mobile-context-caret" v-if="window.scrollY <= 24 || $route.meta.isListing" />

    </core-avatar>

    <i class="fa fa-bars mobile-context" :class="{'is-home': $route.meta.isHome}" v-on:click="onContextClick" v-if="$route.meta.isCommunity && !$route.meta.isHome" />

    <div class="mobile-center" :style="{marginTop: titleTop}">

        <div class="mobile-title">{{ title }}<small v-if="$route.meta.mobilesubtitle">{{ $route.meta.mobilesubtitle }}</small></div>

        <portal-target name="mobilesummary" class="mobile-tags" v-if="!$route.meta.mobilesubtitle" />

    </div>

</div>

<portal-target :class="{'has-scrolled': window.scrollY > 0 && hasColumns}" :style="{marginTop: mobileTop}" name="mobileactions" class="mobile-actions" v-if="$route.meta.hasActions" multiple />

</fragment>

</template>

<script>

import comLogo from './head/Logo'

export default {

    components: {
        comLogo
    },

    computed: {

        hasColumns: function() {

            return !this.$route.meta.hasColumns.call(this)

        },

        title: function() {

            return (this.$_.isFunction(this.$route.meta.mobiletitle)) ? this.$route.meta.mobiletitle.call(this) : this.$route.meta.mobiletitle

        },

        mobileTop: function() {

            var offset = (0 - this.window.scrollY)

            if (offset < -40) offset = -40

            return offset.toString() + 'px'

        },

        marginTop: function() {

            return (0 - this.window.scrollY).toString() + 'px'

        },

        titleTop: function() {

            if (this.window.scrollY < 40 || this.$route.meta.isListing) return false

            return (0 - (this.window.scrollY - 40)).toString() + 'px'

        }

    },

    methods: {

        onContextClick: function() {

            this.$emit('context')

        }

    }

}

</script>

<style scoped>

.mobile-brand {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    z-index: 100000002;
    height: 40px;
    background-color: #0d3144;
}

.mobile-actions {
    position: fixed;
    left: 10px;
    right: 10px;
    top: 80px;
    height: 40px;
    width: calc(100% - 20px);
    z-index: 100000002;
    background-color: #fff;
    height: 50px;
    display: grid;
    padding: 10px 0px 0px 0px;
    grid-gap: 2px;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.mobile-actions.has-scrolled {
    left: 0px;
    right: 0px;
    width: 100%;
    padding: 10px 10px 0px 10px;
	box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px;
}

.mobile-actions >>> .button.theme-filter {
    border-radius: 4px;
    margin: 0px;
    background-color: #4881bb;
    color: #fff;
    box-shadow: none;
    padding: 0px;
}

.mobile-actions >>> .button.theme-filter .button-caret {
    margin-right: 6px;
}

.mobile-actions >>> .button.theme-filter .button-content {
    padding-left: 0px;
}

.mobile {
    width: calc(100% - 20px);
    z-index: 100000001;
    position: fixed;
    left: 10px;
    top: 40px;
    height: 49px;
}

.is-listing .mobile {
    background-color: #fff;
}

.mobile-context {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    top: 8px;
    left: 0px;
    position: absolute;
    z-index: 2;
}

.mobile-context-caret {
    position: absolute;
    right: -12px;
    top: 10px;
    font-size: 12px;
    color: #343434;
}

.mobile-context.fa {
    line-height: 32px;
    text-align: left;
    color: #343434;
    font-size: 24px;
}

.mobile-context.fa.is-home {
    color: #fff;
}

#app:not(.is-listing) .mobile.has-scrolled .mobile-context {
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.mobile-center {
    position: absolute;
    left: 0px;
    top: 0px;
    display: flex;
    height: 50px;
    justify-content: center;
    width: 100%;
    align-items: center;
    flex-direction: column;
}

.is-listing .mobile-center {
    margin-top: 0px!important;
}

.mobile-title {
    color: #343434;
    font-family: 'Barlow', sans-serif;
    font-size: 16px;
    letter-spacing: 1px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.mobile-title small {
    font-size: 12px;
    font-weight: 400;
    opacity: 0.6;
}

.mobile-tags {
	display: flex;
	flex-direction: row;
    gap: 2px;
	flex-wrap: wrap;
	align-items: center;
	justify-content: flex-start;
}

</style>
